module.exports = __webpack_public_path__ + "static/media/Stonk.3ccbdcf4.mp4";